<template>
    <div>
      <h1>这是新页面</h1>
    </div>
  </template>
   
  <script>
  export default {
    name: 'NewPage'
  }
  </script>
   
  <style scoped>
  h1 {
    color: blue;
  }
  </style>


// WEBPACK FOOTER //
// src/views/Test.vue